import { createUseStyles } from 'react-jss';

export default createUseStyles(
  {
    root: {
      display: 'flex',
      flexDirection: 'column',
      flexGrow: 1,
      justifyContent: 'end',
    },
  },
  { name: 'SidebarLogin' },
);
